export var InstagramStepsEnum;
(function (InstagramStepsEnum) {
    InstagramStepsEnum[InstagramStepsEnum["INSTAGRAM_OVERVIEW"] = 0] = "INSTAGRAM_OVERVIEW";
    InstagramStepsEnum[InstagramStepsEnum["COMMERCIAL_FACEBOOK"] = 1] = "COMMERCIAL_FACEBOOK";
    InstagramStepsEnum[InstagramStepsEnum["PROFESSIONAL_INSTAGRAM"] = 2] = "PROFESSIONAL_INSTAGRAM";
    InstagramStepsEnum[InstagramStepsEnum["LINKED_ACCOUNTS"] = 3] = "LINKED_ACCOUNTS";
    InstagramStepsEnum[InstagramStepsEnum["MESSAGES_ACCESS"] = 4] = "MESSAGES_ACCESS";
    InstagramStepsEnum[InstagramStepsEnum["BLIP_CONNECTION"] = 5] = "BLIP_CONNECTION";
    InstagramStepsEnum[InstagramStepsEnum["INTAGRAM_CONNECTED"] = 6] = "INTAGRAM_CONNECTED";
    InstagramStepsEnum[InstagramStepsEnum["CONNECT_PAGE"] = 7] = "CONNECT_PAGE";
    InstagramStepsEnum[InstagramStepsEnum["CONNECT_PAGE_ERROR"] = 8] = "CONNECT_PAGE_ERROR";
    InstagramStepsEnum[InstagramStepsEnum["INSTAGRAM_NOT_LINKED_ERROR"] = 9] = "INSTAGRAM_NOT_LINKED_ERROR";
    InstagramStepsEnum[InstagramStepsEnum["CONNECTED_BOT_ERROR"] = 10] = "CONNECTED_BOT_ERROR";
    InstagramStepsEnum[InstagramStepsEnum["DISABLED_ACCESS_INSTAGRAM_MESSAGES_ERROR"] = 11] = "DISABLED_ACCESS_INSTAGRAM_MESSAGES_ERROR";
    InstagramStepsEnum[InstagramStepsEnum["ENABLE_PERMISSION_ERROR"] = 12] = "ENABLE_PERMISSION_ERROR";
    InstagramStepsEnum[InstagramStepsEnum["CONFIGURATION_EMAIL"] = 13] = "CONFIGURATION_EMAIL";
})(InstagramStepsEnum || (InstagramStepsEnum = {}));
